import React from 'react';
import { theme } from '../../theme';

interface Props {
  open: boolean;
  count: number;
  current?: number;
  onReveal: () => void;
  onClose: () => void;
}

export const MysteryCardModal: React.FC<Props> = ({ open, count, current = 1, onReveal, onClose }) => {
  if (!open) return null;

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) onClose();
  };

  return (
    <div
      onClick={handleOverlayClick}
      role="presentation"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1002,
      }}
    >
      <button
        type="button"
        onClick={onClose}
        aria-label="Cerrar"
        style={{
          position: 'absolute',
          top: 24,
          right: 24,
          background: 'transparent',
          border: 'none',
          color: theme.colors.white,
          fontSize: '28px',
          cursor: 'pointer',
          padding: 8,
        }}
      >
        ✕
      </button>

      <button
        type="button"
        data-testid="mystery-card"
        onClick={onReveal}
        style={{
          width: '90%',
          maxWidth: '360px',
          backgroundColor: theme.colors.surface,
          borderRadius: theme.borderRadius.card,
          border: `2px solid ${theme.colors.primary}`,
          padding: theme.spacing.lg,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          cursor: 'pointer',
          color: theme.colors.text,
          fontFamily: theme.fonts.body,
        }}
      >
        <span style={{ fontSize: '64px', marginBottom: theme.spacing.md }} aria-hidden>🎁</span>
        <span
          style={{
            fontSize: theme.fonts.sizeSubtitle,
            fontWeight: theme.fonts.weightBold,
            color: theme.colors.primary,
            fontFamily: theme.fonts.heading,
            letterSpacing: theme.fonts.letterSpacingWide,
            textAlign: 'center',
            marginBottom: theme.spacing.xs,
          }}
        >
          🏆 Tenés un logro nuevo
        </span>
        <span
          style={{
            color: theme.colors.textSecondary,
            fontSize: theme.fonts.sizeBody,
            textAlign: 'center',
          }}
        >
          Tocá para descubrirlo
        </span>
        {count > 1 && (
          <span
            style={{
              color: theme.colors.textSecondary,
              fontSize: theme.fonts.sizeSmall,
              marginTop: theme.spacing.md,
            }}
          >
            {current} / {count}
          </span>
        )}
      </button>
    </div>
  );
};
